import { render, staticRenderFns } from "./TabifiedContent.vue?vue&type=template&id=5cf99df0&"
import script from "./TabifiedContent.vue?vue&type=script&lang=js&"
export * from "./TabifiedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports